var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.216181 0.235054C0.281837 0.161728 0.362218 0.10307 0.452078 0.062912C0.541938 0.0227542 0.639257 0.0019989 0.737681 0.0019989C0.836106 0.0019989 0.933425 0.0227542 1.02328 0.062912C1.11314 0.10307 1.19353 0.161728 1.25918 0.235054L8.11318 7.60305L14.9682 0.233055C15.0338 0.159729 15.1142 0.101071 15.2041 0.0609131C15.2939 0.0207553 15.3913 0 15.4897 0C15.5881 0 15.6854 0.0207553 15.7753 0.0609131C15.8651 0.101071 15.9455 0.159729 16.0112 0.233055C16.1503 0.386777 16.2274 0.586714 16.2274 0.794052C16.2274 1.00139 16.1503 1.20133 16.0112 1.35505L8.63418 9.28505C8.56853 9.35838 8.48814 9.41703 8.39828 9.45719C8.30842 9.49735 8.21111 9.5181 8.11268 9.5181C8.01426 9.5181 7.91694 9.49735 7.82708 9.45719C7.73722 9.41703 7.65684 9.35838 7.59118 9.28505L0.216181 1.35705C0.077047 1.20333 0 1.00339 0 0.796051C0 0.588713 0.077047 0.388776 0.216181 0.235054Z",
    fill: "#59617B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.c85b6087.svg";
export { ForwardRef as ReactComponent };